export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

export const enableBodyScroll = () => {
  document.body.style.overflow = 'unset';
};

export const toggleBodyScroll = (isDisabled: boolean) => {
  if (isDisabled) {
    disableBodyScroll();
  } else {
    enableBodyScroll();
  }
};
